import React, { useState, useRef } from 'react';
import { ReactComponent as ArrowRight } from 'images/new-icons/arrow-right.svg';
import s from './Products.module.scss';
import useGetAllProducts from 'sdk/hooks/shop/useGetAllProducts';
import useIsAuth from 'sdk/hooks/useIsAuth';
import { useNavigate } from 'react-router-dom';
import ProductCard from '../ProductsByCategory/ProductCard';
import clsx from 'clsx';
import useGetProductReviews from 'sdk/hooks/shop/useGetProductReviewsByProductId';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';
import { useProductSorting } from 'sdk/hooks/shop/useProductSorting';
import { useTranslation } from 'react-i18next';

const Products = () => {
    const {t} = useTranslation() as any
    const { data: isAuthData } = useIsAuth();
    const userId = isAuthData?.user?.id;
    const { data: products } = useGetAllProducts();
    const { data: allReviews } = useGetProductReviews('*');
    const { data: cartData } = useGetOrdersInTheCart(userId);
    const navigate = useNavigate();
    const newArrivalsRef = useRef(null);
    const [selectedCategory, setSelectedCategory] = useState('1');

    const categories = {
        '1': 'All',
        '2': 'Top Rated',
        '3': 'Popular',
        '4': 'New Arrivals',
    }

    const sortedProducts = useProductSorting(products, selectedCategory, allReviews, cartData);

    const servicesTitle = (text) => (
        <div className={s.services_title}>
            <div className={s.services_title_title}>{t(text)}</div>
            <div className={s.services_title_see}>
                <div onClick={() => navigate(`/all-products-shop/${selectedCategory}`)}>{t("See All")}</div>
                <ArrowRight />
            </div>
        </div>
    );

    return (
        <div className={s.container}>
            <div className={s.products_categories}>
                {Object.entries(categories).map(([key, value]) => (
                    <div
                        key={key}
                        onClick={() => setSelectedCategory(key)}
                        className={clsx(
                            s.products_categories_item,
                            selectedCategory === key && s.products_categories_item_active
                        )}
                    >
                        {t(value)}
                    </div>
                ))}
            </div>
            <div ref={newArrivalsRef}>
                {servicesTitle(categories[selectedCategory])}
            </div>
            <div className={s.products}>
                <div className={s.grid}>
                    {sortedProducts?.map((item) => (
                        <ProductCard
                            key={item.id}
                            product={item}
                            userId={userId}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Products;
